<!-- 海口应收账单据打印模板 -->
<template>
    <div v-loading="loading">
        <div id="printRecContent" class="print-zone">
            <div style="margin:0 auto; width: 763px;">
                <div id="top">
                    <div class="print-title-view">
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ titleConfig.RValue }}</div>
                    </div>
                </div>
                <div id="table">
                     <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse;table-layout:fixed;" bordercolor="#333333" id="mtable">
                        <thead>
                            <tr style="text-align:center;font-weight: bold;">
                                <td style="width: 5%;">
                                    <div><b>序号</b></div>
                                </td>
                                <td style="width: 25%;">
                                    <div><b>客户名称</b></div>
                                </td>
                                <td style="width: 9%;">
                                    <div><b>单据</b></div>
                                </td>
                                <td style="width:20%;">
                                    <div><b>单据号</b></div>
                                </td>
                                <td style="width: 11%;">
                                    <div><b>单据日期</b></div>
                                </td>
                                <td style="width: 15%;">
                                    <div><b>挂账金额</b></div>
                                </td>
                                <td style="width: 15%">
                                    <div><b>欠款余额</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in orderList">
                                <td style="text-align:center;">{{ Number(index) + 1 }}</td>
                                <td>{{ AP.EntpCusName }}</td>
                                <td>{{ AP.OrderType == 0 ? '销售收款' : AP.OrderType == 1 ? '销售退货' : '建账' }}</td>
                                <td>{{ AP.OrderCode }}</td>
                                <td>{{ AP.CreateTime }}</td>
                                <td style="text-align: right;">{{ AP.OrderType != 1 ? (AP.IsAgent&&AP.AgentAmount!=0?AP.AgentAmount:AP.TotalAmount) : -(AP.IsAgent&&AP.AgentAmount!=0?AP.AgentAmount:AP.TotalAmount) }}&nbsp;</td>
                                <td style="text-align: right;">
                                    {{
                                        AP.OrderType != 1
                                            ? AP.IsAgent
                                                ? (AP.TotalAmount - AP.AgentAmount - AP.AlreadyPaid).toFixed(2)
                                                : (AP.TotalAmount - AP.AlreadyPaid).toFixed(2)
                                            : -(AP.TotalAmount - AP.AlreadyPaid).toFixed(2)
                                    }}&nbsp;
                                </td>
                            </tr>
                            <tr style="text-align:center;font-weight: bold;">
                                <td colspan="5">
                                    <div><b>合计</b></div>
                                </td>
                                <td width="15%" align="right">{{ allPrice }}&nbsp;</td>
                                <td width="15%" align="right">{{ allPrice1 }}&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>                   
                </div>
                <div id="foot">
                    <table border="0" cellspacing="0" cellpadding="0" style="width:95%;color: #000;font-weight: bold; text-align: right;margin: 5px auto;">
                        <tbody>
                            <tr style="line-height: 28px;">
                                <td colspan="5">打印日期：{{ printDate }}</td>
                            </tr>
                            <tr style="line-height: 28px;">
                                <td style="width: 98.22px;" align="left">
                                    <div>账单签收人：</div>
                                </td>
                                <td style="border-bottom:2px solid #000;width:188.45px;"></td>
                                <td style="width:123.22px;">
                                    <div>付款时间确认：</div>
                                </td>
                                <td style="border-bottom:2px solid #000;width:188.45px;"></td>
                                <td style="137.75px" align="center">制单人：{{ employeeName }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="order-remark" style="width:95%;margin: 0 auto;">
                        备注：以上账单的原签名（白联单）单据已发出，未付款金额以此账表为准。
                    </div>
                    <div style="text-align: center;padding: 10px 0px;font-size: 16px;color: #000;font-weight: bold;width: 100%;margin: 0 auto;line-height: 40px;">
                        <div style="border: 1px solid #000;padding: 3px 0px;">
                            <div style="width:20%;display: inline-block;">年</div>
                            <div style="width:40%;display: inline-block;">账单合计金额：</div>
                            <div style="width:20%;display: inline-block;">元</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="re-set">
                    <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" v-print="'#printRecContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: false,
            type: Boolean
        },
        ordersList: {
            type: Array,
            default: () => {}
        },
        isDefaultSet: {
            default: false,
            type: Boolean
        },
        isPreview: {
            default: false,
            type: Boolean
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            allPrice: 0,
            allPrice1: 0,
            employeeName: userMsg.EmployeeName,
            printDate: '',
            orderList: [],
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '出库对账单'
            } //标题配置
        };
    },
    watch: {},
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            let that = this;
            that.getConfigByCodes().then(() => {
                let amount = 0;
                let amount1 = 0;
                that.orderList = [...that.ordersList];
                that.orderList.forEach((e, i) => {
                    if (e.OrderType != 1) amount +=(e.IsAgent&&e.AgentAmount!=0)?e.AgentAmount: e.TotalAmount;
                    else amount += -((e.IsAgent&&e.AgentAmount!=0)?e.AgentAmount: e.TotalAmount);

                    amount1 += Number(
                        e.OrderType != 1
                            ? e.IsAgent
                                ? (e.TotalAmount - e.AgentAmount - e.AlreadyPaid).toFixed(2)
                                : (e.TotalAmount - e.AlreadyPaid).toFixed(2)
                            : -(e.TotalAmount - e.AlreadyPaid).toFixed(2)
                    );
                });
                that.allPrice = amount.toFixed(2);
                that.allPrice1 = amount1.toFixed(2);
                that.orderLis = that.orderList.sort(function(a, b) {
                    return new Date(a.CreateTime.replace(/-/g, '/')).getTime() - new Date(b.CreateTime.replace(/-/g, '/')).getTime();
                });

                let d = new Date();
                let year1, month1, day1;
                [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
                that.printDate = `${year1}-${month1}-${day1}`;

                if (that.isInit) that.loading = false;
                else {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            that.lodopPrint();
                        }, 100);
                    });
                }
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyszglmxbt'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyszglmxbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '出库对账单';
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                    body{margin: 0 auto;width: 210m;}               
                    .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 20px 0;
                    }

                    .print-title-view .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    }                 
               `;
                let tableStyle = `
                    #mtable table,
                    #mtable td,
                    #mtable th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                     /* 为了兼容火狐不换行 */
                    #mtable td{
                        word-break: break-all;word-wrap: break-word;
                    }                     
              
                `;
                let footStyle = `
                    .order-remark {
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        color: #000;
                        font-weight: bold;
                        padding: 5px 0px 5px 0px;
                        position: relative;
                    }                
                `;
                LODOP.PRINT_INIT('打印出库对账单');
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                let printContentHeight = document.getElementById('printRecContent').clientHeight;
                //这是签名的横线，因为样式不起作用，所以用来画直线的接口实现
                // LODOP.ADD_PRINT_LINE(bot - 36, 103, bot - 36, 270, 0, 1);
                // LODOP.ADD_PRINT_LINE(bot - 36, 430, bot - 36, 600, 0, 1);

                console.log(document.getElementById('printRecContent'))
                let topHeight = document.querySelector('#printRecContent #top').clientHeight;
                let tableHeight = document.querySelector('#printRecContent #table').clientHeight;
                let footHeight = document.querySelector('#printRecContent #foot').clientHeight;
                // let printTableH = 1080 - topHeight - footHeight;
                let printTableH = 1080 - topHeight;
                let pageFootTop = 1080;
                if (printContentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    pageFootTop = printContentHeight;
                    // printTableH = 950;
                }

                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printRecContent #top').innerHTML);
                LODOP.ADD_PRINT_TABLE(topHeight, 0, '100%', printTableH, `<style>${tableStyle}</style>` + document.querySelector('#printRecContent #table').innerHTML);
                // LODOP.SET_PRINT_STYLEA(0, 'TableHeightScope', 2); //高度包含页头

                // //次页开始的上边距偏移量
                // LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -topHeight + 3);
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', document.querySelector('#printRecContent #foot').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);
                //放在底部会被页尾的内容遮挡
                LODOP.ADD_PRINT_HTM(10, 690, 300, 10, "<font><span tdata='pageNO' format='#'>第#页</span> / <span tdata='pageCount' format='#'>共#页</span></font>");
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 1);
                // LODOP.ADD_PRINT_HTM(pageFootTop, 15, 300, 10, '<font>出库对账单</font>');
                // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                // LODOP.PRINT_DESIGN();
                
                if (!this.isInit) this.orderList = [];
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        }
    }
};
</script>
<style lang="less" scoped media="print">
.print-zone {
    width: 210mm;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 0;
}

.print-title-view .print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.print-table-main {
    width: 792px;
    font-size: 14px;
}
.print-table-main .theader {
    text-align: center;
    font-weight: bold;
}
.print-table-main .tcen {
    text-align: center;
}
.print-table-main .tright {
    text-align: right;
    padding-right: 5px;
}
.print-table-main .div-table-cell {
    overflow: hidden;
    word-break: break-all;
    word-wrap: break-word;
    height: auto;
    line-height: 25px;
    padding-left: 1px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    color: #000;
    box-sizing: border-box;
}
.print-table-main .div-table-row {
    border-left: 1px solid #000;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    // justify-content: right;
    justify-content: space-between;
    margin-top: 20px;
}
.btn-ctn-left {
    display: flex;
}
.re-submit {
    text-align: right;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #000;
    font-weight: bold;
    padding: 5px 0px 5px 0px;
}
.pdate {
    text-align: right;
    display: block;
}
.uline {
    position: relative;
    margin-right: 20px;
}
.uline::after {
    content: '';
    width: 65%;
    height: 1px;
    background-color: #000;
    position: absolute;
    z-index: 1;
    left: 85px;
    bottom: 0px;
    border-bottom: 1px solid #000;
}
.sec::after {
    left: 96px;
}
#mtable table,
#mtable td,
#mtable th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
</style>
